import type { ChatMessageDirection } from 'cpool-constants';
import type { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';

import { PanelSection } from './PanelSection';
import { CHAT_STATUS_PILL_CLASSES, deriveChatStatusLabel } from '~/features/whatsapp/utils/deriveChatStatus';
import { cn } from '~/utils/cnTailwind';

type Props = {
    lastInboundAt: number | null | undefined;
    lastMessageAt: number | null;
    lastMessageDirection: ChatMessageDirection | null | undefined;
};

// "Anfragen gesamt" (Figma) is omitted — no resolver counts loan requests by phone.
export const StatusSection = ({ lastInboundAt, lastMessageAt, lastMessageDirection }: Props) => {
    const { t } = useTranslation();
    const statusLabel = deriveChatStatusLabel({ lastInboundAt, lastMessageAt, lastMessageDirection });

    return (
        <PanelSection title={t('WHATSAPP_CHAT.USER_INFO.STATUS.TITLE')} open>
            <div className="flex items-center gap-2 py-1.5 text-sm text-midnight">
                <span className="w-24 shrink-0 text-grey">{t('WHATSAPP_CHAT.USER_INFO.STATUS.STATUS_LABEL')}</span>
                <span
                    className={cn(
                        'rounded-full px-2 py-0.5 text-xs font-semibold',
                        CHAT_STATUS_PILL_CLASSES[statusLabel],
                    )}
                >
                    {t(`WHATSAPP_CHAT.STATUS.${statusLabel.toUpperCase()}` as ParseKeys)}
                </span>
            </div>
        </PanelSection>
    );
};
